import { render, staticRenderFns } from "./JdsButton.vue?vue&type=template&id=7caf5195&scoped=true&"
import script from "./JdsButton.vue?vue&type=script&lang=ts&"
export * from "./JdsButton.vue?vue&type=script&lang=ts&"
import style0 from "./JdsButton.vue?vue&type=style&index=0&id=7caf5195&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7caf5195",
  null
  
)

export default component.exports